import { cn } from '@/lib/utils';
import React from 'react';
import { LuSearch } from 'react-icons/lu';

interface ISearchbar extends React.InputHTMLAttributes<HTMLInputElement> {
  labelClassName?: string;
}

export const Searchbar = ({ labelClassName, className, ...props }: ISearchbar) => {
  return (
    <label
      className={cn(
        'flex w-full max-w-[280px] items-center gap-2 rounded-xl border border-secondary-border bg-white-100 px-3.5 py-2.5 focus-within:border-brand-600',
        labelClassName
      )}
    >
      <LuSearch className='size-4 flex-none text-quaternary-400' aria-hidden />
      <input
        {...props}
        className={cn(
          'w-full border-none bg-transparent !p-0 text-[13.5px] text-primary-900 outline-none placeholder:text-other-textPlaceholder focus:border-0 focus:outline-none focus:ring-0',
          className
        )}
      />
    </label>
  );
};
